import { render, staticRenderFns } from "./vector-inspiration-header.vue?vue&type=template&id=7e89a779&"
import script from "./vector-inspiration-header.vue?vue&type=script&lang=js&"
export * from "./vector-inspiration-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports